if ( typeof VerticalSlider !== 'function' ) {

	class VerticalSlider extends HTMLElement {

		constructor(){
			super();
      this.init();
    }

    init(){

      this.slides = [];
      this.slide = 0;
      this.currentActiveSlide = 0;
      this.querySelectorAll('.slide').forEach(elm=>{
        this.slides.push({
          parent: elm,
          children: elm.querySelector('.card'),
          media: elm.querySelectorAll('.js-parallax-media'),
          text: elm.querySelector('.card__text')
        })
      });

      this.zoom = this.hasAttribute('data-zoom') ? true : false;
      this.prlx = this.hasAttribute('data-prlx') ? true : false;

      this.siteHeader = document.querySelector('.mount-header');

      this.slideRaf = true;

      this.onScrollHandler = (()=>{
        if ( this.slideRaf ) {
          this.slideRaf = false;
          requestAnimationFrame(this.slideAnimation.bind(this));
        }
      }).bind(this);
      window.addEventListener('scroll', this.onScrollHandler, {passive:true});
      window.addEventListener('resize', this.onScrollHandler, {passive:true});
      this.onScrollHandler();

      // Initialize mute/unmute buttons
      this.initMuteButtons();
      
      // Initialize button states after a short delay to ensure videos are loaded
      setTimeout(() => {
        this.initializeButtonStates();
      }, 500);

    }

    initializeButtonStates(){
      // Set initial button states based on video muted status
      this.querySelectorAll('[data-js-video-mute-button]').forEach(button => {
        const videoId = button.dataset.videoId;
        const videoComponent = document.getElementById(videoId);
        if (videoComponent) {
          // Try to find video in the container (after template is loaded)
          let video = videoComponent.querySelector('[data-js-video-component-container] video');
          // If not found, try direct query
          if (!video) {
            video = videoComponent.querySelector('video');
          }
          if (video) {
            const muteIcon = button.querySelector('.vertical-slider__video-mute-icon--mute');
            const volumeIcon = button.querySelector('.vertical-slider__video-mute-icon--volume');
            if (video.muted) {
              if (muteIcon) muteIcon.style.display = 'inline-block';
              if (volumeIcon) volumeIcon.style.display = 'none';
              button.setAttribute('aria-label', 'Unmute video');
              button.setAttribute('title', 'Unmute video');
            } else {
              if (muteIcon) muteIcon.style.display = 'none';
              if (volumeIcon) volumeIcon.style.display = 'inline-block';
              button.setAttribute('aria-label', 'Mute video');
              button.setAttribute('title', 'Mute video');
            }
          }
        }
      });
    }

    initMuteButtons(){
      // Add event listeners to all mute buttons
      this.querySelectorAll('[data-js-video-mute-button]').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const videoId = button.dataset.videoId;
          const videoComponent = document.getElementById(videoId);
          if (videoComponent) {
            // Try to find video in the container (after template is loaded)
            let video = videoComponent.querySelector('[data-js-video-component-container] video');
            // If not found, try to find it in the template
            if (!video) {
              const template = videoComponent.querySelector('template');
              if (template) {
                video = template.content.querySelector('video');
              }
            }
            // If still not found, try direct query
            if (!video) {
              video = videoComponent.querySelector('video');
            }
            if (video) {
              this.toggleVideoMute(video, button);
            }
          }
        });
      });
    }

    toggleVideoMute(video, button){
      const muteIcon = button.querySelector('.vertical-slider__video-mute-icon--mute');
      const volumeIcon = button.querySelector('.vertical-slider__video-mute-icon--volume');
      
      if (video.muted) {
        video.muted = false;
        if (muteIcon) muteIcon.style.display = 'none';
        if (volumeIcon) volumeIcon.style.display = 'inline-block';
        button.setAttribute('aria-label', 'Mute video');
        button.setAttribute('title', 'Mute video');
      } else {
        video.muted = true;
        if (muteIcon) muteIcon.style.display = 'inline-block';
        if (volumeIcon) volumeIcon.style.display = 'none';
        button.setAttribute('aria-label', 'Unmute video');
        button.setAttribute('title', 'Unmute video');
      }
    }

    muteAllVideos(){
      // Mute all videos and update button states
      this.querySelectorAll('[data-js-video-mute-button]').forEach(button => {
        const videoId = button.dataset.videoId;
        const videoComponent = document.getElementById(videoId);
        if (videoComponent) {
          // Try to find video in the container (after template is loaded)
          let video = videoComponent.querySelector('[data-js-video-component-container] video');
          // If not found, try direct query
          if (!video) {
            video = videoComponent.querySelector('video');
          }
          if (video && !video.muted) {
            video.muted = true;
            const muteIcon = button.querySelector('.vertical-slider__video-mute-icon--mute');
            const volumeIcon = button.querySelector('.vertical-slider__video-mute-icon--volume');
            if (muteIcon) muteIcon.style.display = 'inline-block';
            if (volumeIcon) volumeIcon.style.display = 'none';
            button.setAttribute('aria-label', 'Unmute video');
            button.setAttribute('title', 'Unmute video');
          }
        }
      });
    }

    slideAnimation(e){
      
      const sliderOffset = this.parentElement.getBoundingClientRect().y+window.scrollY,
            scrollTop = window.scrollY,
            sliderHeight = Math.min(this.slides[0].children.offsetHeight, window.innerHeight + (!this.classList.contains('vertical-slider--no-padding') ? (KROWN.settings.grid_padding * 2) : 0) - (document.body.classList.contains('header-is-sticky') ? this.siteHeader.offsetHeight : 0));
            
      let newActiveSlide = -1;
            
      this.slides.forEach((item, i)=>{

        let slideY = (scrollTop - sliderOffset + (window.innerHeight - sliderHeight)) - ( sliderHeight * i ),
            slideYXZ = slideY - (window.innerHeight - sliderHeight);

        if ( item.media[0] && item.parent.getBoundingClientRect().y < window.innerHeight && item.parent.getBoundingClientRect().y > -window.innerHeight ) {
          if ( scrollTop <= sliderOffset ) {
            if ( i == 0 || (item.parent.getBoundingClientRect().y + item.parent.offsetHeight <= window.innerHeight)) {
              item.media.forEach(elm=>{
                elm.style.transform = `${this.zoom ? `scale(1)` : ''} ${this.prlx ? `translateY(0)` : ''}`;
              });
              item.children.style.transform = `scale(1)`;
              if (i === 0) newActiveSlide = 0;
            } else {
              item.media.forEach(elm=>{
                const mediaScale = (100 - (slideY * 100 / sliderHeight) / 12);
                elm.style.transform = `${this.zoom ? `scale(${Math.max(100, mediaScale)}%)` : ''} ${this.prlx ? `translateY(${mediaScale <= 100 ? 0 : slideY/2}px)` : ''}`;
              });
              item.children.style.transform = `${this.zoom ? `scale(1)` : ''}`;
            }
          } else if ( slideY >= 0 && slideYXZ <= 0 ) {
            item.media.forEach(elm=>{
              elm.style.transform = `${this.zoom ? `scale(1)` : ''} ${this.prlx ? `translateY(0)` : ''}`;
            });
            item.children.style.transform = `${this.zoom ? `scale(1)` : ''}`;
            newActiveSlide = i;
          } else if ( slideY < 0 ) {
            item.media.forEach(elm=>{
              elm.style.transform = `${this.zoom ? `scale(${(100 - (slideY * 100 / sliderHeight) / 12)}%)` : ''} ${this.prlx ? `translateY(${slideY/2}px)` : ''}`;
            });
          } else if ( slideYXZ > 0 && i != this.slides.length - 1 ) {
            item.media.forEach(elm=>{
              elm.style.transform = `${this.prlx ? `translateY(${-slideYXZ/4}px)` : ''}`;
            });
            item.children.style.transform = `${this.zoom ? `scale(${(100 - (slideYXZ * 100 / sliderHeight) / 12)}%)` : ''}`;
          } 
        }
      });

      // Check if slide changed and mute all videos if it did
      if (newActiveSlide !== -1 && newActiveSlide !== this.currentActiveSlide) {
        const previousActiveSlide = this.currentActiveSlide;
        this.currentActiveSlide = newActiveSlide;
        // Only mute if we're switching to a different slide (not on initial load)
        if (previousActiveSlide !== -1 && previousActiveSlide !== newActiveSlide) {
          this.muteAllVideos();
        }
      }

      this.slideRaf = true;

    }

  }

  if ( typeof customElements.get('vertical-slider') == 'undefined' ) {
		customElements.define('vertical-slider', VerticalSlider);
	}

}